'use client'

import React, { ReactElement, ReactNode } from 'react'
import Button from '@/components/common/button/Button'
import { ButtonType } from '@/components/common/button/ButtonType'
import { useTranslations } from 'next-intl'

export interface FilterControlButtonsProps {
  reset: () => void
  apply: () => void
  resetLabel: ReactNode
}

export default function FilterControlButtons(props: FilterControlButtonsProps): ReactElement {
  const t = useTranslations('SearchPage')

  return (
    <div className="z-80 absolute bottom-0 flex w-full justify-between rounded-b-md border-t-[1px] bg-white px-2 py-2 lg:static">
      <button className=" h-full px-2 py-2 font-medium text-stone-600" onClick={props.reset}>
        {props.resetLabel}
      </button>
      <Button buttonType={ButtonType.PRIMARY} onClick={props.apply} className="text-white">
        {t('buttonApply')}
      </Button>
    </div>
  )
}
